module.exports = __webpack_public_path__ + "static/img/logo_plain.e996ea5b.svg";